<template>
  <div class="">

  <v-container class="play-page hero" fluid>
  <!-- <top-nav-bar :user="user"/> -->
                
    <v-btn block tile color="red darken-4" class="mt-5 mb-2 d-flex align-start flex-column" @click="goTo('/')"><v-icon class="mr-1" size="17">mdi-arrow-left</v-icon> BACK TO DASHBOARD</v-btn>

    <v-row class="pl-2 pr-2">
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="main-play-page pl-4 pr-4" outlined style="background-color:rgb(16,16,16)">
      <update-name />
      <update-password />
      <clear-history />
      </v-col>

    </v-row>
  </v-container>

    <!-- <page-header title="Details Update" back-button="account" v-if="mobile" /> -->

  </div>
</template>

<script>
import UpdateName from "@/sections/UpdateName";
import UpdatePassword from "@/sections/UpdatePassword";
import ClearHistory from "@/sections/ClearHistory";
// import PageHeader from "@/sections/PageHeader";
// import TopNavBar from "@/sections/TopNavBar";

export default {
  components: {
    UpdateName,
    UpdatePassword,
    ClearHistory,
    // PageHeader,
    // TopNavBar,

  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods:{
      goTo(path) {
        this.$router.push({ path: path }).catch(() => {
          this.drawer = false;
        });
      },
  }
};
</script>

<style lang="sass" scoped>
.sheet-form
  background: rgb(37, 37, 37)
</style>